/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest,
  PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
  PostApiV1AccesscontrolPermissionsUpsertBatch400,
  PostApiV1AccesscontrolPermissionsUpsertBatch401,
  PostApiV1AccesscontrolPermissionsUpsertBatch500,
} from "../../types/accessControlPermissionsController/PostApiV1AccesscontrolPermissionsUpsertBatch.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1AccesscontrolPermissionsUpsertBatch } from "../../clients/accessControlPermissionsController/postApiV1AccesscontrolPermissionsUpsertBatch.ts";

export const postApiV1AccesscontrolPermissionsUpsertBatchMutationKey = () =>
  [{ url: "/api/v1/accesscontrol/permissions/upsert-batch" }] as const;

export type PostApiV1AccesscontrolPermissionsUpsertBatchMutationKey =
  ReturnType<typeof postApiV1AccesscontrolPermissionsUpsertBatchMutationKey>;

export function postApiV1AccesscontrolPermissionsUpsertBatchMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = postApiV1AccesscontrolPermissionsUpsertBatchMutationKey();
  return mutationOptions<
    PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1AccesscontrolPermissionsUpsertBatch400
      | PostApiV1AccesscontrolPermissionsUpsertBatch401
      | PostApiV1AccesscontrolPermissionsUpsertBatch500
    >,
    { data?: PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1AccesscontrolPermissionsUpsertBatch(data, config);
    },
  });
}

/**
 * @description Cria ou atualiza permissões para todos os usuários de um role em múltiplos controllers. **(Requer Authorization para autenticação)**
 * @summary Upsert permissões em lote (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/permissions/upsert-batch}
 */
export function usePostApiV1AccesscontrolPermissionsUpsertBatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
      ResponseErrorConfig<
        | PostApiV1AccesscontrolPermissionsUpsertBatch400
        | PostApiV1AccesscontrolPermissionsUpsertBatch401
        | PostApiV1AccesscontrolPermissionsUpsertBatch500
      >,
      { data?: PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1AccesscontrolPermissionsUpsertBatchMutationKey();

  const baseOptions =
    postApiV1AccesscontrolPermissionsUpsertBatchMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
      ResponseErrorConfig<
        | PostApiV1AccesscontrolPermissionsUpsertBatch400
        | PostApiV1AccesscontrolPermissionsUpsertBatch401
        | PostApiV1AccesscontrolPermissionsUpsertBatch500
      >,
      { data?: PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest },
      TContext
    >;

  return useMutation<
    PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1AccesscontrolPermissionsUpsertBatch400
      | PostApiV1AccesscontrolPermissionsUpsertBatch401
      | PostApiV1AccesscontrolPermissionsUpsertBatch500
    >,
    { data?: PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
    ResponseErrorConfig<
      | PostApiV1AccesscontrolPermissionsUpsertBatch400
      | PostApiV1AccesscontrolPermissionsUpsertBatch401
      | PostApiV1AccesscontrolPermissionsUpsertBatch500
    >,
    { data?: PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest },
    TContext
  >;
}
